import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach stored token (JWT for email/password, or Google session token) as Bearer
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pawtrack_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => localStorage.setItem("pawtrack_token", t);
export const clearToken = () => localStorage.removeItem("pawtrack_token");
